export const APP_ROUTES = {
	unauthenticated: {
		login: '/login',
		recoverPassword: '/recover-password',
		resetPassword: '/reset-password',
		createAccountPage: '/create-account',
		customerSignUpPage: '/account-creation/customer',
		providerSignUpPage: '/account-creation/provider',
	},

	authenticated: {
		customers: {
			// general routes
			home: '/home',
			createAccountSuccess: '/customer/account-creation/success',
			onBoardingProfilePic: '/customer/onboarding-profile-pic',
			enableNotifications: '/customer/enable-notifications',

			// service progress
			activeServiceRequests: '/customer/active-service-requests',

			// account routes
			account: '/customer/account',
			editContactDetails: '/customer/account/edit-contact-details',

			// onboarding routes
			uploadProfilePic: '/customer/onboarding/upload-profile-picture',

			// edit address routes
			addOrEditAddressAddress: '/customer/account/add-or-edit-address',
			addOrEditAddressAddressWithParams: '/customer/account/add-or-edit-address/:addressIndex',

			// new address
			newAddress: '/customer/new-address',
			newAddressMoreDetails: '/customer/new-address-details',
			newAddressDrivewayImagePrefix: '/customer/new-address-driveway-image',
			newAddressDrivewayImageWithSlug: '/customer/new-address-driveway-image/:addressIndex',
			unserviceableAlert: '/customer/unserviceable-location',

			// service request
			newServiceRequest: '/customer/new-service-request',

			// service request
			customerNotifications: '/customer/notifications',
			viewProgressPrefix: '/customers/view-progress',
			viewProgressWithSlug: '/customers/view-progress/:requestID',

			viewRequestProvider: '/customers/request/view-provider',
			viewRequestProviderWithSlug: '/customers/request/view-provider/:requestID',

			// service history
			serviceHistory: '/customer/service-history',
			serviceHistoryWithSlug: '/customer/service-history/:requestID',
		},

		providers: {
			// general routes
			home: '/home',
			createAccountSuccess: '/provider/account-creation/success',
			account: '/provider/account',
			editContactDetails: '/provider/account-edit/contact-details',
			editDriverDetails: '/provider/account-edit/driver-details',
			editTravelDistance: '/provider/account-edit/travel-distance',
			editDriversLicense: '/provider/account-edit/drivers-license',
			editInsurance: '/provider/account-edit/insurance',
			editEquipment: '/provider/account-edit/equipment',
			editVehicle: '/provider/account-edit/vehicle',
			editAccountPreferences: '/provider/account-edit/account-preferences',

			// service request
			providerNotifications: '/provider/notifications',

			// activation request workflow
			activationRequest: '/provider/activation-request',
			stripeIncompleteAccount: '/provider/stripe/incomplete-account',
			stripeCheckAccountStatus: '/provider/stripe/check-account-status',
			jobDetailsPrefix: '/provider/job-details',
			jobDetailsWithSlug: '/provider/job-details/:requestID',
			unassignedRequests: '/provider/view-available-jobs',
			activeRequests: '/provider/view-active-jobs',
			jobsMap: '/provider/jobs-map',
			requestCompletionPrefix: '/provider/service-progress',
			requestCompletionWithSlug: '/provider/service-progress/:requestID',

			uploadProfilePicture: '/provider/onboarding/upload-profile-picture',
			enableNotifications: '/provider/enable-notifications',

			viewRequestCustomer: '/provider/request/view-customer',
			viewRequestCustomerWithSlug: '/provider/request/view-customer/:requestID',

			awaitingQuikplowReview: '/provider/awaiting-account-review',

			// history
			jobHistory: '/provider/job-history',
			jobHistoryWithSlug: '/provider/job-history/:requestID',
		},
	},

	shared: {
		notFound: '/not-found',
		support: '/shared/support',
		customerFaq: '/shared/customer-faq',
		providerFaq: '/shared/provider-faq',
		contactUs: '/shared/contact-us',
		contactSubmission: '/shared/contact-submission-success',
	},

	development: {
		home: '/development',
		typography: '/development/typography',
		formFields: '/development/form-fields',
		icons: '/development/icons',
	},
}
